import { Reducer } from "redux";

import { Pipeline } from "@/Contracts/Pipelines";

import {
	PipelinesActionTypes,
	PipelinesActions
} from "../../Actions/Pipelines";

export interface PipelinesState {
	readonly isLoading: boolean;
	readonly pipelineList: Pipeline[];
	readonly currentActivePipeline: Pipeline | null;
	readonly isConfigurePipelineDrawerOpen: boolean;
	readonly isAddingPipeline: boolean;
	readonly isDeletingPipeline: boolean;
}

export const initialPipelineState: PipelinesState = {
	isLoading: false,
	pipelineList: new Array<Pipeline>(),
	currentActivePipeline: null,
	isConfigurePipelineDrawerOpen: false,
	isAddingPipeline: false,
	isDeletingPipeline: false
};

export const PipelinesReducer: Reducer<PipelinesState, PipelinesActions> = (
	state: PipelinesState = initialPipelineState,
	action: PipelinesActions
): PipelinesState => {
	switch (action.type) {
		case PipelinesActionTypes.SHOW_PIPELINES_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case PipelinesActionTypes.HIDE_PIPELINES_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case PipelinesActionTypes.CONFIGURE_PIPELINE_DRAWER_OPENED: {
			return {
				...state,
				isConfigurePipelineDrawerOpen: true,
				isAddingPipeline: action.isAddingPipeline,
				isDeletingPipeline: action.isDeletingPipeline
			};
		}
		case PipelinesActionTypes.CONFIGURE_PIPELINE_DRAWER_CLOSED: {
			return {
				...state,
				currentActivePipeline: null,
				isConfigurePipelineDrawerOpen: false,
				isAddingPipeline: false,
				isDeletingPipeline: false
			};
		}
		case PipelinesActionTypes.PIPELINES_REQUESTED: {
			return state;
		}
		case PipelinesActionTypes.PIPELINES_SUCCESSFUL: {
			return {
				...state,
				pipelineList: action.pipelineList
			};
		}
		case PipelinesActionTypes.PIPELINES_FAILED: {
			return state;
		}
		case PipelinesActionTypes.PIPELINE_DETAILS_REQUESTED: {
			return state;
		}
		case PipelinesActionTypes.PIPELINE_DETAILS_SUCCESSFUL: {
			return state;
		}
		case PipelinesActionTypes.PIPELINE_DETAILS_FAILED: {
			return state;
		}
		case PipelinesActionTypes.PIPELINE_DETAILS_UPDATED: {
			return state;
		}
		case PipelinesActionTypes.ADD_PIPELINE_REQUESTED: {
			return state;
		}
		case PipelinesActionTypes.ADD_PIPELINE_SUCCESSFUL: {
			return state;
		}
		case PipelinesActionTypes.ADD_PIPELINE_FAILED: {
			return state;
		}
		case PipelinesActionTypes.EDIT_PIPELINE_REQUESTED: {
			return state;
		}
		case PipelinesActionTypes.EDIT_PIPELINE_SUCCESSFUL: {
			return state;
		}
		case PipelinesActionTypes.EDIT_PIPELINE_FAILED: {
			return state;
		}
		case PipelinesActionTypes.SET_CURRENT_PIPELINE: {
			return {
				...state,
				currentActivePipeline: action.currentPipeline
			};
		}
		case PipelinesActionTypes.DELETE_PIPELINE_OR_STAGE_REQUESTED: {
			return state;
		}
		case PipelinesActionTypes.DELETE_PIPELINE_OR_STAGE_IN_PROGRESS: {
			return state;
		}
		case PipelinesActionTypes.DELETE_PIPELINE_OR_STAGE_FAILED: {
			return state;
		}
		default: {
			return state;
		}
	}
};

export default PipelinesReducer;
